module.exports = __webpack_public_path__ + "img/tfsb3.943064cd.png";